// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CreateGuidedChangeEventModalQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type CreateGuidedChangeEventModalQuery = { __typename?: 'Query', project:
    | { __typename?: 'StandaloneProject', id: string, shouldAccrueAsComplete: boolean, stage: { __typename?: 'ProjectStage', id: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Region', id: string, shouldAccrueAsComplete: boolean, stage: { __typename?: 'ProjectStage', id: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Market', id: string, shouldAccrueAsComplete: boolean, stage: { __typename?: 'ProjectStage', id: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Community', id: string, shouldAccrueAsComplete: boolean, stage: { __typename?: 'ProjectStage', id: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Subdivision', id: string, shouldAccrueAsComplete: boolean, stage: { __typename?: 'ProjectStage', id: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Lot', id: string, shouldAccrueAsComplete: boolean, stage: { __typename?: 'ProjectStage', id: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Structure', id: string, shouldAccrueAsComplete: boolean, stage: { __typename?: 'ProjectStage', id: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Unit', id: string, shouldAccrueAsComplete: boolean, stage: { __typename?: 'ProjectStage', id: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
  , enumDetails: { __typename?: 'AllEnumDetails', changeEventWorkflow: Array<{ __typename?: 'ChangeEventWorkflowDetail', code: Types.ChangeEventWorkflow, name: string, description: string }> } };

export type CreateGuidedChangeEventModal_ChangeEventQueryVariables = Types.Exact<{
  changeEventId: Types.Scalars['ID']['input'];
}>;


export type CreateGuidedChangeEventModal_ChangeEventQuery = { __typename?: 'Query', changeEvent: { __typename?: 'ChangeEvent', id: string, workflow?: { __typename?: 'ChangeEventWorkflowDetail', code: Types.ChangeEventWorkflow } | null | undefined, reason: { __typename?: 'ChangeEventReason', id: string }, type: { __typename?: 'ChangeEventTypeDetail', code: Types.ChangeEventType }, projectStage: { __typename?: 'ProjectStage', id: string } } };

export type CreateGuidedChangeEventModal_ChangeEventFragment = { __typename?: 'ChangeEvent', id: string, workflow?: { __typename?: 'ChangeEventWorkflowDetail', code: Types.ChangeEventWorkflow } | null | undefined, reason: { __typename?: 'ChangeEventReason', id: string }, type: { __typename?: 'ChangeEventTypeDetail', code: Types.ChangeEventType }, projectStage: { __typename?: 'ProjectStage', id: string } };

export const CreateGuidedChangeEventModal_ChangeEventFragmentDoc = gql`
    fragment CreateGuidedChangeEventModal_ChangeEvent on ChangeEvent {
  id
  workflow {
    code
  }
  reason {
    id
  }
  type {
    code
  }
  projectStage {
    id
  }
}
    `;
export const CreateGuidedChangeEventModalDocument = gql`
    query CreateGuidedChangeEventModal($projectId: ID!) {
  project(id: $projectId) {
    id
    stage(stage: CONSTRUCTION) {
      id
    }
    lotType {
      code
      clientNoun
    }
    shouldAccrueAsComplete
  }
  enumDetails {
    changeEventWorkflow {
      code
      name
      description
    }
  }
}
    `;

/**
 * __useCreateGuidedChangeEventModalQuery__
 *
 * To run a query within a React component, call `useCreateGuidedChangeEventModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateGuidedChangeEventModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateGuidedChangeEventModalQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateGuidedChangeEventModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables> & ({ variables: CreateGuidedChangeEventModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables>(CreateGuidedChangeEventModalDocument, options);
      }
export function useCreateGuidedChangeEventModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables>(CreateGuidedChangeEventModalDocument, options);
        }
// @ts-ignore
export function useCreateGuidedChangeEventModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables>;
export function useCreateGuidedChangeEventModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateGuidedChangeEventModalQuery | undefined, CreateGuidedChangeEventModalQueryVariables>;
export function useCreateGuidedChangeEventModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables>(CreateGuidedChangeEventModalDocument, options);
        }
export type CreateGuidedChangeEventModalQueryHookResult = ReturnType<typeof useCreateGuidedChangeEventModalQuery>;
export type CreateGuidedChangeEventModalLazyQueryHookResult = ReturnType<typeof useCreateGuidedChangeEventModalLazyQuery>;
export type CreateGuidedChangeEventModalSuspenseQueryHookResult = ReturnType<typeof useCreateGuidedChangeEventModalSuspenseQuery>;
export type CreateGuidedChangeEventModalQueryResult = ApolloReactCommon.QueryResult<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables>;
export const CreateGuidedChangeEventModal_ChangeEventDocument = gql`
    query CreateGuidedChangeEventModal_ChangeEvent($changeEventId: ID!) {
  changeEvent(id: $changeEventId) {
    ...CreateGuidedChangeEventModal_ChangeEvent
  }
}
    ${CreateGuidedChangeEventModal_ChangeEventFragmentDoc}`;

/**
 * __useCreateGuidedChangeEventModal_ChangeEventQuery__
 *
 * To run a query within a React component, call `useCreateGuidedChangeEventModal_ChangeEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateGuidedChangeEventModal_ChangeEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateGuidedChangeEventModal_ChangeEventQuery({
 *   variables: {
 *      changeEventId: // value for 'changeEventId'
 *   },
 * });
 */
export function useCreateGuidedChangeEventModal_ChangeEventQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CreateGuidedChangeEventModal_ChangeEventQuery, CreateGuidedChangeEventModal_ChangeEventQueryVariables> & ({ variables: CreateGuidedChangeEventModal_ChangeEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreateGuidedChangeEventModal_ChangeEventQuery, CreateGuidedChangeEventModal_ChangeEventQueryVariables>(CreateGuidedChangeEventModal_ChangeEventDocument, options);
      }
export function useCreateGuidedChangeEventModal_ChangeEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateGuidedChangeEventModal_ChangeEventQuery, CreateGuidedChangeEventModal_ChangeEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreateGuidedChangeEventModal_ChangeEventQuery, CreateGuidedChangeEventModal_ChangeEventQueryVariables>(CreateGuidedChangeEventModal_ChangeEventDocument, options);
        }
// @ts-ignore
export function useCreateGuidedChangeEventModal_ChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CreateGuidedChangeEventModal_ChangeEventQuery, CreateGuidedChangeEventModal_ChangeEventQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateGuidedChangeEventModal_ChangeEventQuery, CreateGuidedChangeEventModal_ChangeEventQueryVariables>;
export function useCreateGuidedChangeEventModal_ChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateGuidedChangeEventModal_ChangeEventQuery, CreateGuidedChangeEventModal_ChangeEventQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateGuidedChangeEventModal_ChangeEventQuery | undefined, CreateGuidedChangeEventModal_ChangeEventQueryVariables>;
export function useCreateGuidedChangeEventModal_ChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateGuidedChangeEventModal_ChangeEventQuery, CreateGuidedChangeEventModal_ChangeEventQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreateGuidedChangeEventModal_ChangeEventQuery, CreateGuidedChangeEventModal_ChangeEventQueryVariables>(CreateGuidedChangeEventModal_ChangeEventDocument, options);
        }
export type CreateGuidedChangeEventModal_ChangeEventQueryHookResult = ReturnType<typeof useCreateGuidedChangeEventModal_ChangeEventQuery>;
export type CreateGuidedChangeEventModal_ChangeEventLazyQueryHookResult = ReturnType<typeof useCreateGuidedChangeEventModal_ChangeEventLazyQuery>;
export type CreateGuidedChangeEventModal_ChangeEventSuspenseQueryHookResult = ReturnType<typeof useCreateGuidedChangeEventModal_ChangeEventSuspenseQuery>;
export type CreateGuidedChangeEventModal_ChangeEventQueryResult = ApolloReactCommon.QueryResult<CreateGuidedChangeEventModal_ChangeEventQuery, CreateGuidedChangeEventModal_ChangeEventQueryVariables>;